import {IxFetch, IxApi} from "vue-src/IxPlugin/api"

export default {
  namespaced:true,
  state:{
    methods:[],
    loaded:false,
    error:false,
    promise:null,
  },
  mutations:{
    SET_LOADED(state){
      state.loaded = true
    },
    SET_LOADING(state){
      state.loaded = false
    },
    SET_ERROR(state, payload){
      state.error = payload
    },
    SET_METHODS(state, payload){
      state.methods = payload
    },
    SET_PROMISE(state, payload){
      state.promise = payload
    }
  },
  actions:{
    async fetch({commit, state}){
      try{
        commit('SET_LOADING')
        commit('SET_PROMISE', IxFetch(IxApi.paymentmethods))
        let response = await state.promise
        if(response.status === 200){
          commit('SET_METHODS', response.data.results)
          commit('SET_LOADED')
        }
        return response
      }catch(e){
        commit('SET_ERROR', e)
        return e
      }
    }
  }
}


// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/payment-methods.js